import differenceInYears from 'date-fns/differenceInYears';
import { parseISO } from 'date-fns';

export const getAgeFromDateString = (dateString: string): number => {
  return differenceInYears(new Date(), parseISO(dateString));
};
